<mat-toolbar class="fx-card-toolbar fx-gap-4" color="primary">
  <h3 class="text-2xl font-semibold">{{ "STAFF_CONTRACTS" | translate }}</h3>

  <span class="fx-grow-1"></span>

  <button
    mat-raised-button color="primary"
    [routerLink]="'/setting/edit-staff-contract'"
  >
    <mat-icon
      fontIcon="mdi-plus"
      fontSet="mdi"
    ></mat-icon>
    {{ "ADD_NEW" | translate }}
  </button>
</mat-toolbar>

<ng-template #searchTemplate>
    <div [formGroup]="filterForm"></div>
</ng-template>
@if (isLoadingResults || isRateLimitReached) {
    <mat-progress-bar
            mode="indeterminate"
    ></mat-progress-bar>
}
<div class="relative fx-layout-column-nowrap ft-setting-card-width">
  <mat-table
    [dataSource]="dataSource"
    class="fx-grow-1 fx-overflow-auto"
    style="height: calc(100vh - 164px) !important;"
    [trackBy]="trackById"
    matSort
    matSortActive="name"
    matSortDirection="asc"
    matSortDisableClear
  >
    <!--Table-->
    @for (col of displayedColumns; track $index) {
    <ng-container cdkColumnDef="{{ col.label }}" [class.hidden]="col.hidden">
      <mat-header-cell
        *cdkHeaderCellDef
        mat-sort-header="{{ col.value }}"
        [disabled]="!col.sortable"
      >
        {{ col.header | translate }}</mat-header-cell
      >

      <ng-container>
        <mat-cell *cdkCellDef="let row">
          {{ row[col.label] | translate }}</mat-cell
        >
      </ng-container>
    </ng-container>
    }

    <!--actions-->
    <ng-container cdkColumnDef="action">
      <mat-header-cell *cdkHeaderCellDef></mat-header-cell>
      <mat-cell *cdkCellDef="let row">
        <button
          mat-icon-button
          [routerLink]="'/setting/edit-staff-contract'"
          [queryParams]="{ id: row.id }"
        >
          <mat-icon
            class="edit-icon-gradient"
            fontIcon="mdi-pencil"
            fontSet="mdi"
          ></mat-icon>
        </button>
        <button
          mat-icon-button
          (click)="$event.stopPropagation(); deleteStaffContract(row)"
        >
          <mat-icon
            class="delete-icon-gradient"
            fontIcon="mdi-delete"
            fontSet="mdi"
          ></mat-icon>
        </button>
      </mat-cell>
    </ng-container>

    <!--header-->
    <mat-header-row *cdkHeaderRowDef="cols; sticky: true"></mat-header-row>
    <mat-row [@rowsAnimation]="" *cdkRowDef="let row; columns: cols"> </mat-row>
  </mat-table>

  <mat-paginator
    [length]="resultsLength"
    [pageIndex]="0"
    [pageSize]="25"
    [pageSizeOptions]="[5, 10, 25, 100]"
    [showFirstLastButtons]="true"
  >
  </mat-paginator>
</div>
